<template>
    <div>
        <div class="mt-4 mb-5 text-left">
            <p class="text-lg mb-1">¡Gracias por afiliarte!</p>
            <p class="text-sm text-muted"><b>Paso {{ step }}:</b> {{ step == 1 ? 'Completa tu perfil.' : step == 2 ? 'Ingrese al menos 1 número de teléfono.' : ''}}</p>
        </div>
        <form @submit.prevent="COMPLETE()">
            <div class="row" v-if="step == 1">
                <div class="col-12 px-0" v-if="data.account_type == 2">
                    <div class="form-group mb-2">
                        <small class="input-title">Nombre de la Empresa</small>
                        <input type="text" class="form-control" v-model="data.company"
                            :class="errors.company ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.company"
                            :key="index">{{ error }}</small>
                    </div>                
                </div>
                <div class="col-lg-6 px-0 pl-lg-0 pr-lg-2" v-if="data.account_type != 2">
                    <div class="form-group mb-2">
                        <small class="input-title">Nombre</small>
                        <input type="text" class="form-control"
                            v-model="data.first_name" :class="errors.first_name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.first_name"
                            :key="index">{{ error }}</small>
                    </div>                
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2" v-if="data.account_type != 2">
                    <div class="form-group mb-2">
                        <small class="input-title">Apellido</small>
                        <input type="text" class="form-control" v-model="data.last_name"
                            :class="errors.last_name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.last_name"
                            :key="index">{{ error }}</small>
                    </div>                
                </div>
                <div class="col-lg-6 px-0 pl-lg-0 pr-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Tipo de cuenta</small>
                        <v-select v-model="data.account_type" :items="accounts.filter((e) => e.value != 0)" hide-details
                            @change="CHANGE"
                            class="form-control"
                            :class="errors.account_type ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.account_type"
                            :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Genero</small>
                        <v-select v-model="data.gender"
                            :items="genders"
                            hide-details
                            class="form-control"
                            :class="errors.gender ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.gender" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-12 px-0">
                    <div class="form-group mb-2">
                        <small class="input-title">{{ data.account_type != 2 ? 'Identificación' : 'Cédula Jurídica' }}</small>
                        <input type="text" class="form-control" v-mask="format" v-model="data.identification" :class="errors.identification ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.identification" :key="index">{{ error }}</small>
                        <small v-if="data.account_type == 2">Ejemplo: Si es 3-101-123456 se debe digitar 3101123456</small>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="step == 2">
                <div class="col-lg-6 px-0 pl-lg-0 pr-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Tel. Casa: </small>
                        <input type="text" class="form-control form-control-sm" v-model="data.phone" @keypress="NUMBER" :class="errors.phone ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.phone" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Tel. Celular: </small>
                        <input type="text" class="form-control form-control-sm" v-model="data.mobil" @keypress="NUMBER" :class="errors.mobil ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.mobil" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pl-lg-0 pr-lg-2">
                    <div class="d-flex">
                        <div class="w-75">
                            <div class="form-group mb-2">
                                <small class="input-title">Tel. Trabajo: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.phone_work" @keypress="NUMBER" :class="errors.phone_work ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.phone_work" :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="w-25 pl-2">
                            <div class="form-group mb-2">
                                <small class="input-title">Ext.: </small>
                                <input type="text" class="form-control form-control-sm" v-model="data.phone_work_ext" @keypress="NUMBER" :class="errors.phone_work_ext ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.phone_work_ext" :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Otro: </small>
                        <input type="text" class="form-control form-control-sm" v-model="data.phone_other" @keypress="NUMBER" :class="errors.phone_other ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.phone_other" :key="index">{{ error }}</small>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="step == 3">
                <div class="col-lg-6 px-0 pl-lg-0 pr-lg-2">
                    <div class="form-group mb-2">
                        <small class="input-title">Entregar en: </small>
                        <v-select v-model="data.deliver_to"
                            :items="delivers"
                            hide-details
                            @change="FRESH"
                            class="form-control form-control-sm"
                            :class="errors.branch ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.deliver_to" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2" v-if="data.deliver_to == 1">
                    <div class="form-group mb-2">
                        <small class="input-title">Sucursal: </small>
                        <v-select v-model="data.branch_office_id"
                            item-value="id"
                            item-text="name"
                            :items="branch_offices.filter((e) => e.id == 1)"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.branch_office_id ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.branch_office_id" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="col-lg-6 px-0 pr-lg-0 pl-lg-2" v-else>
                    <div class="form-group mb-2">
                        <small class="input-title">Dirección: </small>
                        <input type="text" class="form-control form-control-sm" v-model="data.address" :class="errors.address ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.address" :key="index">{{ error }}</small>
                    </div>
                </div>
                <div class="row" v-if="data.deliver_to == 0">
                    <div class="col-lg-3 px-0 pl-lg-0 pr-lg-2">
                        <div class="form-group mb-2">
                            <small class="input-title">País: </small>
                            <v-select v-model="data.country_id"
                                :items="countries"
                                item-text="name"
                                item-value="id"
                                hide-details
                                @change="PROVINCES"
                                class="form-control form-control-sm"
                                :class="errors.country_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.country_id" :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-lg-3 px-0 pl-lg-0 pr-lg-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Provincia: </small>
                            <v-select v-model="data.province_id"
                                :items="provinces"
                                item-text="name"
                                item-value="id"
                                hide-details
                                @change="CITIES"
                                class="form-control form-control-sm"
                                :class="errors.province_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.province_id" :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-lg-3 px-0 pl-lg-0 pr-lg-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Cuidad: </small>
                            <v-select v-model="data.city_id"
                                :items="cities"
                                item-text="name"
                                item-value="id"
                                hide-details
                                @change="DISTRICTS"
                                class="form-control form-control-sm"
                                :class="errors.city_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.city_id" :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-lg-3 px-0 pr-lg-0 pl-lg-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Distrito: </small>
                            <v-select v-model="data.district_id"
                                :items="districts"
                                item-text="name"
                                item-value="id"
                                hide-details
                                class="form-control form-control-sm"
                                :class="errors.district_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.district_id" :key="index">{{ error }}</small>
                        </div>
                    </div>  
                </div>
            </div>
            <div class="form-group mt-1" :class="step > 1 ? 'd-flex gap-2' : 'd-block'">
                <button type="button" :class="step > 1 ? 'w-50' : 'w-100'" v-if="step > 1" @click="LAST()" class="btn btn-dark btn-x mb-2">
                    <span>Anterior</span>
                </button>
                <button type="submit" :class="step > 1 ? 'w-50' : 'w-100'" class="btn btn-primary btn-x">
                    <div class="spinner-border spinner-border-sm" role="status"
                        v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>{{ step == 3 ? 'Completar' : 'Siguiente' }}</span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            data: {},
            errors: {},
            count: 0,
            genders: [
                { value: null, text: 'Otro' },
                { value: 0, text: 'Masculino' },
                { value: 1, text: 'Femenino' }
            ],
            delivers: [
                { value: 0, text: 'Dirección' },
                { value: 1, text: 'Sucursal' }
            ],
            identifications: [
                { value: 1, text: 'Cédula Nacional' },
                { value: 2, text: 'Cédula Juridica' },
                { value: 3, text: 'Cédula de Residencia (DIMEX)' },
                { value: 4, text: 'Pasaporte' },
            ],
            countries: [],
            provinces: [],
            cities: [],
            districts: [],
            branch_offices: [],
            hash: this.$route.query.hash,
            step: this.$route.query.step || 1,
        }
    },
    computed: {
        ...mapGetters([
            'accounts',
            'permissions'
        ]),
        format: function(){
            let format = ''
            if(this.data.identification_type == 1){
                format = '0#-####-####'
            } else if(this.data.identification_type == 2){
                format = '3-###-######'
            } else if(this.data.identification_type == 3){
                format = '1############'
            } else {
                format = '9#################'
            }
            return format
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        LAST: function(){
            let vue = this
            vue.$router.replace({ name: 'CompleteAccount', query: { hash: vue.hash, step: vue.step - 1 }})
        },
        FRESH: function(){
            let vue = this
            vue.data.country_id = ''
            vue.data.province_id = ''
            vue.data.city_id = ''
            vue.data.district_id = ''
            vue.data.address = ''
            vue.data.branch_office_id = ''
            if(vue.data.deliver_to == 1){
                vue.BRANCH_OFFICES()
            }else{
                vue.COUNTRIES()
            }
        },
        BRANCH_OFFICES: function(){
            let vue = this
            axios({url: '/all/branch-offices', method: 'GET' })
            .then((resp) => {
                vue.branch_offices = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        COUNTRIES: function(){
            let vue = this
            axios({url: '/locations/countries', method: 'GET' })
            .then((resp) => {
                vue.countries = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        PROVINCES: function(){
            let vue = this
            axios({url: '/locations/provinces/'+ vue.data.country_id, method: 'GET' })
            .then((resp) => {
                vue.provinces = resp.data
            })
            .finally((resp) => {
                if(vue.data.province_id){
                    vue.CITIES()
                }
            })
        },
        CITIES: function(){
            let vue = this
            axios({url: '/locations/cities/'+ vue.data.province_id, method: 'GET' })
            .then((resp) => {
                vue.cities = resp.data
            })
            .finally((resp) => {
                if(vue.data.city_id){
                    vue.DISTRICTS()
                }
            })
        },
        DISTRICTS: function(){
            let vue = this
            axios({url: '/locations/districts/'+ vue.data.city_id, method: 'GET' })
            .then((resp) => {
                vue.districts = resp.data
            })
        },
        INIT: function () {
            let vue = this
            axios({ url: '/verify/token/' + vue.hash, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data.data
                    if(vue.data){
                        if(vue.data.deliver_to == 0){
                            vue.COUNTRIES()
                        }else{
                            if(vue.data.deliver_to == 1){
                                vue.BRANCH_OFFICES()
                            }
                        }
                    }else{
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'Login' })
                    }
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                    vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.$router.push({ name: 'Login' })
                })
        },
        COMPLETE: function () {
            let vue = this
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                vue.data.step = vue.step
                axios({ url: '/complete/account/' + vue.hash, method: 'POST', data: vue.data })
                    .then((resp) => {
                        if(vue.step == 3){
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.$store.dispatch('INIT_USER', resp.data.data)
                            if (vue.permissions[0]) {
                                if (vue.permissions[0].items.length > 0) {
                                    vue.$router.push({ name: vue.permissions[0].items[0].route })
                                } else {
                                    vue.$router.push({ name: vue.permissions[0].route })
                                }
                            } else {
                                vue.$router.push({ name: 'P403' })
                            }
                        }else{
                            vue.$router.replace({ name: 'CompleteAccount', query: { hash: vue.hash, step: resp.data.step }})
                        }
                    })
                    .catch((err) => {
                        if (err.response.status !== 422) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
};
</script>
  